import React, { Fragment } from "react";
import SingleRow from "../../common/SingleRow";
import InputCard from "../../common/InputCard";

class BottomLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.cardsLayout = [
      // cards
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];
        card.items.map((item, i) => {
          if (
            props[c][inputName][i] &&
            item.item.intemName === props[c][inputName][i].name
          ) {
            item.item.value =
              props[c][inputName][i].value === undefined ||
              props[c][inputName][i].value === "" ||
              props[c][inputName][i].value === false
                ? ""
                : props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
          }
          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.bottomData);
    const card = this.cardsLayout;
    return (
      <Fragment>
        <InputCard jsonObj={card[0]} setCardsInfo={this.getCardsInfo} />
        <SingleRow jsonObj={card[1]} setCardsInfo={this.getCardsInfo} />
      </Fragment>
    );
  };

  render() {
    return (
      <Fragment>
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default BottomLayout;
